<template>
  <div class="profile-page">
    <common-header />
    <div class="profile-body">
      <!-- 用户信息区域 -->
      <div
        class="user-info-section bg-white radius-20 padding-30 margin-bottom-20"
        v-loading="loading"
      >
        <div class="flex align-center">
          <div class="">
            <img
              class="w-74 h-74 radius-50"
              :src="userInfo.avatar || require('@/assets/images/login.png')"
              alt="avatar"
            />
          </div>
          <div class="user-details flex-sub margin-left-12">
            <div class="text-14 flex align-center">
              <div class="text-666-color w-56">手机号：</div>
              <span class="info-value text-000-color">{{
                userInfo.mobile || "--"
              }}</span>
            </div>
            <div class="text-14 margin-top-10 flex align-center text-right">
              <div class="text-666-color w-56">邮　箱：</div>
              <span class="info-value text-000-color">{{
                userInfo.email || "--"
              }}</span>
            </div>
            <div class="text-14 margin-top-10 flex align-center">
              <div class="text-666-color w-56">银行卡：</div>
              <span class="info-value text-000-color">{{
                maskedBankAccount
              }}</span>
              <el-button
                v-if="userInfo.bank_account && !showFullBankAccount"
                type="text"
                class="show-bank-btn"
                @click="handleShowBankAccount"
                >显示</el-button
              >
            </div>
          </div>
          <div class="flex">
            <el-button
              class="email-code-btn flex align-center justify-center"
              @click="handleEmailCode"
              >邮箱编辑</el-button
            >
            <el-button
              class="edit-btn flex align-center justify-center"
              @click="handleEdit"
              >编辑</el-button
            >
            <el-button
              class="edit-btn flex align-center justify-center"
              @click="handleOpenChangePasswordDialog"
            >
              修改密码</el-button
            >
            <el-button
              class="logout-btn flex align-center justify-center"
              type="danger"
              @click="handleLogout"
              >退出登录</el-button
            >
          </div>
        </div>
      </div>

      <!-- 主要内容区域 -->
      <div class="main-content flex">
        <!-- 左侧：推广中心 -->
        <div
          class="promotion-center bg-white radius-20 padding-25 flex-sub margin-right-20"
        >
          <div class="flex align-center justify-between">
            <span class="text-000-color text-bold">我的分佣</span>
            <div class="flex align-center">
              <span class="text-21-color padding-right-8"
                >我的邀请码：{{ userInfo.invite_code || "--" }}</span
              >
              <img
                src="@/assets/images/icon12.png"
                class="w-17 h-17"
                @click="handleCopyInvitationCode"
              />
            </div>
          </div>
          <div class="promotion-table margin-top-20">
            <div class="promotion-table-wrapper">
              <div class="promotion-title text-000-color text-bold">
                推广人数
              </div>
              <el-table
                :data="promotionList"
                style="width: 100%"
                class="promotion-list-table"
                :show-header="true"
              >
                <el-table-column
                  prop="username"
                  label="姓名"
                  width="120"
                  align="center"
                >
                  <template slot-scope="scope">
                    {{ maskNameIfMobile(scope.row.username) }}
                  </template>
                </el-table-column>
                <el-table-column prop="mobile" label="手机号" align="center">
                  <template slot-scope="scope">
                    {{ maskMobile(scope.row.mobile) }}
                  </template>
                </el-table-column>
                <el-table-column
                  prop="commission"
                  label="分享佣金"
                  align="center"
                >
                  <template slot-scope="scope">
                    <span class="text-red"
                      >¥{{ scope.row.commission || 0 }}</span
                    >
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div
              class="promotion-pagination"
              v-if="promotionTotal > 0"
              style="
                padding: 15px 20px 20px;
                display: flex;
                justify-content: flex-end;
              "
            >
              <el-pagination
                background
                layout="prev, pager, next"
                :current-page="promotionPage"
                :page-size="promotionLimit"
                :total="promotionTotal"
                @current-change="handlePromotionPageChange"
              />
            </div>
          </div>
        </div>

        <!-- 右侧：我的分佣 -->
        <div class="commission-section bg-white radius-20 padding-25 flex-sub">
          <span class="text-bold">我的分佣</span>
          <div
            class="balance-info flex justify-between align-center margin-top-20"
          >
            <div class="balance-display flex align-center">
              <img src="@/assets/images/icon11.png" class="w-62 h-62" />
              <span class="balance-label text-14 text-000-color">余额：</span>
              <span class="text-main text-bold" style="color: #ff383c">
                <span>￥</span>
                <span class="text-30" style="">{{ balance }}</span>
              </span>
            </div>
            <el-button
              class="w-102 h-34 bg-main text--white radius-7 flex align-center justify-center"
              type="danger"
              @click="handleWithdraw"
              >提现</el-button
            >
          </div>
          <div class="withdrawal-records margin-top-30">
            <div class="withdrawal-table-wrapper">
              <div class="withdrawal-title text-000-color text-bold">
                提现记录
              </div>
              <el-table
                :data="withdrawalList"
                style="width: 100%"
                class="withdrawal-list-table"
                :show-header="true"
              >
                <el-table-column
                  prop="apply_time_text"
                  label="时间"
                  width="150"
                  align="center"
                ></el-table-column>
                <el-table-column
                  prop="method_text"
                  label="方式"
                  align="center"
                ></el-table-column>
                <el-table-column label="状态" align="center">
                  <template slot-scope="scope">
                    <el-tooltip
                      v-if="scope.row.status === 'rejected'"
                      :content="scope.row.audit_remark || '暂无拒绝原因'"
                      placement="top"
                      :open-delay="300"
                    >
                      <span
                        :class="[
                          'withdraw-status',
                          getWithdrawStatusClass(scope.row.status),
                        ]"
                      >
                        {{ getWithdrawStatusText(scope.row.status) }}
                      </span>
                    </el-tooltip>
                    <span
                      v-else
                      :class="[
                        'withdraw-status',
                        getWithdrawStatusClass(scope.row.status),
                      ]"
                    >
                      {{ getWithdrawStatusText(scope.row.status) }}
                    </span>
                  </template>
                </el-table-column>
                <el-table-column prop="amount" label="金额" align="center">
                  <template slot-scope="scope">
                    <span class="text-main text-bold"
                      >¥{{ scope.row.amount }}</span
                    >
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 提现方式选择弹窗 -->
    <el-dialog
      :visible.sync="withdrawDialogVisible"
      width="505px"
      custom-class="withdraw-dialog"
      :show-close="false"
    >
      <template #title>
        <div class="text-center text-21-color text-bold text-28 padding-top-30">
          提现方式
        </div>
      </template>
      <div class="withdraw-content padding-lr-30">
        <!-- 提现金额输入 -->
        <div class="withdraw-amount-section margin-bottom-30">
          <div class="text-14 text-000-color margin-bottom-10">提现金额</div>
          <el-input
            v-model="withdrawAmount"
            type="number"
            placeholder="请输入提现金额"
            class="withdraw-amount-input"
            :min="0"
            :max="parseFloat(balance) || 0"
          >
            <template slot="prepend">￥</template>
          </el-input>
          <div class="text-12 text-999-color margin-top-10">
            可提现余额：<span class="text-main">￥{{ balance }}</span>
          </div>
        </div>
        <!-- 提现方式选择 -->
        <div class="withdraw-options text-center">
          <div class="text-14 text-000-color margin-bottom-15">
            选择提现方式
          </div>
          <div class="withdraw-radio-group">
            <div
              class="withdraw-option-item"
              v-for="method in withdrawMethods"
              :key="method.id"
              @click="selectedWithdrawMethod = method.id"
            >
              <img
                :src="
                  selectedWithdrawMethod === method.id
                    ? selectedIcon
                    : unselectedIcon
                "
                class="radio-icon"
                alt="radio"
              />
              <div class="text-14 w-42 text-left text-000-color">
                {{ method.name }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div slot="footer" class="flex align-center justify-center">
        <el-button
          class="w-158 h-45 radius-57 text-14 text-main ghost"
          @click="withdrawDialogVisible = false"
          >取消</el-button
        >
        <el-button
          class="w-158 h-45 radius-57 text-14 bg-main text-white solid margin-left-40"
          :loading="withdrawLoading"
          @click="handleWithdrawConfirm"
          >确认</el-button
        >
      </div>
    </el-dialog>

    <!-- 验证码验证弹窗 -->
    <el-dialog
      :visible.sync="verifyDialogVisible"
      width="400px"
      custom-class="verify-dialog"
      :show-close="false"
      :close-on-click-modal="false"
    >
      <template #title>
        <div class="text-center text-21-color text-bold text-20 padding-top-20">
          验证身份
        </div>
      </template>
      <div class="verify-content padding-lr-30">
        <div class="text-14 text-666-color margin-bottom-15 text-center">
          验证码已发送至 {{ userInfo.mobile }}
        </div>
        <el-input
          v-model="verifyCode"
          placeholder="请输入验证码"
          class="verify-code-input"
          maxlength="6"
        >
          <template slot="suffix">
            <span
              class="resend-btn"
              :class="{ disabled: countdown > 0 }"
              @click="countdown === 0 && handleResendCode()"
            >
              {{ countdown > 0 ? `${countdown}s` : "重新发送" }}
            </span>
          </template>
        </el-input>
      </div>
      <div
        slot="footer"
        class="flex align-center justify-center padding-bottom-20"
      >
        <el-button
          class="w-120 h-40 radius-57 text-14 text-main ghost"
          @click="handleCloseVerifyDialog"
          >取消</el-button
        >
        <el-button
          class="w-120 h-40 radius-57 text-14 bg-main text-white solid margin-left-20"
          :loading="verifyLoading"
          @click="handleVerifyCode"
          >确认</el-button
        >
      </div>
    </el-dialog>

    <!-- 授权邮箱弹窗 -->
    <el-dialog
      :visible.sync="emailAuthDialogVisible"
      width="1280px"
      custom-class="email-auth-dialog"
      :show-close="false"
      :close-on-click-modal="true"
    >
      <template #title>
        <div class="email-auth-title text-center text-bold">授权邮箱编辑</div>
      </template>
      <div class="email-auth-content">
        <div class="email-auth-tip text-14 text-999-color">
          最多可设置 {{ maxEmailCount }} 个邮箱<span
            class="text-14 text-999-color"
            >(仅支持QQ邮箱)</span
          >
        </div>
        <div
          class="email-auth-form"
          v-for="(item, index) in emailAuthList"
          :key="item.id || `new-${index}`"
        >
          <div class="email-auth-form-row flex align-center">
            <div class="email-auth-field flex align-center">
              <label class="email-auth-label padding-right-4">邮箱</label>
              <el-input
                v-model.trim="item.email"
                placeholder="请输入邮箱"
                class="email-auth-input"
              />
            </div>
            <div class="email-auth-field flex align-center">
              <label class="email-auth-label padding-right-4">授权码</label>
              <el-input
                v-model.trim="item.auth_code"
                placeholder="请输入授权码（不修改可留空）"
                class="email-auth-input"
              />
            </div>
            <div class="email-auth-field flex align-center">
              <label class="email-auth-label padding-right-4">笔名</label>
              <el-input
                v-model.trim="item.penName"
                placeholder="请输入笔名"
                class="email-auth-input"
              />
            </div>
            <div class="email-auth-actions flex align-center">
              <el-button
                size="mini"
                :type="item.isDefault === '1' ? 'primary' : 'default'"
                @click="handleSetDefaultEmail(item)"
              >
                {{ item.isDefault === "1" ? "默认邮箱" : "设为默认" }}
              </el-button>
              <el-button
                size="mini"
                type="danger"
                plain
                @click="handleDeleteEmail(item, index)"
              >
                删除
              </el-button>
            </div>
          </div>
        </div>
        <div class="email-auth-add-row">
          <el-button
            size="mini"
            plain
            class="email-auth-add-btn"
            :disabled="emailAuthList.length >= maxEmailCount"
            @click="addEmailAuthRow"
          >
            + 新增邮箱
          </el-button>
        </div>
      </div>
      <div slot="footer" class="email-auth-footer text-center">
        <div
          class="text-14 padding-bottom-20 text-main"
          @click="handleEmailAuthorizationCodeTutorial"
        >
          获取邮箱授权码教程
        </div>
        <el-button
          class="email-auth-save-btn"
          :loading="emailAuthLoading"
          @click="handleEmailAuthSave"
        >
          保存
        </el-button>
      </div>
    </el-dialog>
    <!-- 修改密码弹窗 -->
    <el-dialog
      :visible.sync="changePasswordDialogVisible"
      width="460px"
      custom-class="change-password-dialog"
      :show-close="false"
      :close-on-click-modal="false"
    >
      <template #title>
        <div class="text-center text-21-color text-bold text-20 padding-top-20">
          修改密码
        </div>
      </template>
      <div class="padding-lr-30">
        <div class="text-14 text-000-color margin-bottom-8">旧密码</div>
        <el-input
          v-model.trim="changePasswordForm.oldpassword"
          type="password"
          placeholder="请输入旧密码"
          class="margin-bottom-15"
          show-password
        />
        <div class="text-14 text-000-color margin-bottom-8">新密码</div>
        <el-input
          v-model.trim="changePasswordForm.newpassword"
          type="password"
          placeholder="请输入新密码"
          show-password
        />
      </div>
      <div
        slot="footer"
        class="flex align-center justify-center padding-bottom-20"
      >
        <el-button
          class="w-120 h-40 radius-57 text-14 text-main ghost"
          @click="handleCloseChangePasswordDialog"
          >取消</el-button
        >
        <el-button
          class="w-120 h-40 radius-57 text-14 bg-main text-white solid margin-left-20"
          :loading="changePasswordLoading"
          @click="handleChangePasswordSubmit"
          >确认</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import CommonHeader from "@/components/CommonHeader.vue";
import {
  getUserInfo,
  getPromotion,
  sendSmsCode,
  getSenderEmailList,
  addSenderEmail,
  editSenderEmail,
  setDefaultSenderEmail,
  deleteSenderEmail,
  changePassword,
} from "@/api/user";
import { getWithdrawRecords, applyWithdraw } from "@/api/withdraw";
import api from "@/utils/api";

export default {
  name: "Profile",
  components: {
    CommonHeader,
  },
  data() {
    return {
      loading: false,
      userInfo: {},
      invitationCode: "",
      balance: "0",
      withdrawDialogVisible: false,
      withdrawAmount: "",
      withdrawLoading: false,
      selectedWithdrawMethod: "wechat", // 默认选中第一个（微信）
      selectedIcon: require("@/assets/images/icon14.png"), // 选中时显示
      unselectedIcon: require("@/assets/images/icon13.png"), // 未选中时显示
      withdrawMethods: [
        { id: "wechat", name: "微信" },
        { id: "alipay", name: "支付宝" },
        { id: "bank", name: "银行卡" },
      ],
      promotionList: [],
      promotionPage: 1,
      promotionLimit: 10,
      promotionTotal: 0,
      withdrawalList: [],
      withdrawPage: 1,
      withdrawLimit: "10",
      showFullBankAccount: false, // 是否显示完整银行卡号
      verifyDialogVisible: false, // 验证码弹窗
      verifyCode: "", // 验证码
      verifyLoading: false, // 验证加载状态
      countdown: 0, // 倒计时
      countdownTimer: null, // 倒计时定时器
      // 授权邮箱弹窗相关
      emailAuthDialogVisible: false,
      emailAuthLoading: false,
      emailAuthList: [],
      maxEmailCount: 3,
      changePasswordDialogVisible: false,
      changePasswordLoading: false,
      changePasswordForm: {
        oldpassword: "",
        newpassword: "",
      },
    };
  },
  computed: {
    // 银行卡脱敏显示
    maskedBankAccount() {
      if (!this.userInfo.bank_account) {
        return "--";
      }

      // 如果已经验证通过，显示完整卡号
      if (this.showFullBankAccount) {
        return this.userInfo.bank_account;
      }

      const account = this.userInfo.bank_account;
      // 如果卡号长度小于8位，直接返回
      if (account.length <= 8) {
        return account;
      }

      // 显示前4位和后4位，中间用*代替
      const firstFour = account.substring(0, 4);
      const lastFour = account.substring(account.length - 4);
      const middleLength = account.length - 8;
      const masked = "*".repeat(middleLength);

      return `${firstFour}${masked}${lastFour}`;
    },
  },
  mounted() {
    this.fetchUserInfo();
    this.fetchPromotionList();
    this.fetchWithdrawRecords();
  },
  activated() {
    // 每次进入个人中心都重新拉取用户信息，与当前登录 token 保持一致，避免多账号切换后显示错乱
    this.fetchUserInfo();
  },
  beforeDestroy() {
    // 清除倒计时定时器
    if (this.countdownTimer) {
      clearInterval(this.countdownTimer);
    }
  },
  methods: {
    // 提现状态显示（仅使用 status 字段）
    getWithdrawStatusText(status) {
      const statusMap = {
        pending: "待审核",
        approved: "已打款",
        rejected: "已拒绝",
      };
      return statusMap[status] || "-";
    },
    // 提现状态样式
    getWithdrawStatusClass(status) {
      const classMap = {
        pending: "pending",
        approved: "approved",
        rejected: "rejected",
      };
      return classMap[status] || "unknown";
    },
    /**
     * 推广列表手机号脱敏：11 位大陆号展示为 前三 + **** + 后四
     */
    maskMobile(mobile) {
      if (mobile == null || mobile === "") {
        return "--";
      }
      const s = String(mobile).trim();
      if (!s) {
        return "--";
      }
      if (/^\d{11}$/.test(s)) {
        return `${s.slice(0, 3)}****${s.slice(-4)}`;
      }
      // 非标准长度：保留前 2、后 2，中间脱敏；过短则全部掩码
      if (s.length <= 4) {
        return "*".repeat(s.length);
      }
      return `${s.slice(0, 2)}${"*".repeat(s.length - 4)}${s.slice(-2)}`;
    },
    /**
     * 姓名字段若为手机号，则同样脱敏；否则原样展示
     */
    maskNameIfMobile(name) {
      if (name == null || name === "") {
        return "--";
      }

      const s = String(name).trim();
      if (/^\d{11}$/.test(s)) {
        return this.maskMobile(s);
      }

      return s;
    },
    // 获取用户信息
    fetchUserInfo() {
      // 先从 localStorage 获取基本信息作为默认值
      const savedUserInfo = localStorage.getItem("userInfo");
      if (savedUserInfo) {
        try {
          const info = JSON.parse(savedUserInfo);
          this.userInfo.phone = info.mobile || info.phone || "";
          this.userInfo.email = info.email || "";
          this.userInfo.avatar =
            info.avatar || (info.userinfo && info.userinfo.avatar) || "";
          this.userInfo.nickname =
            info.nickname ||
            (info.userinfo && info.userinfo.nickname) ||
            info.username ||
            "";
        } catch (e) {
          console.error("解析用户信息失败:", e);
        }
      }

      // 调用接口获取完整的用户信息
      this.loading = true;
      getUserInfo()
        .then((response) => {
          this.loading = false;
          if (response.data) {
            this.userInfo = response.data;
            // 余额：getUserInfo 返回字段为 money
            const money = response.data.money;
            this.balance =
              money != null && money !== "" ? Number(money).toFixed(2) : "0";
            // 同步头像、昵称到 localStorage，保证顶部导航栏与个人中心展示一致
            const avatar =
              response.data.avatar ||
              (response.data.userinfo && response.data.userinfo.avatar);
            const nickname =
              response.data.nickname ||
              (response.data.userinfo && response.data.userinfo.nickname) ||
              response.data.username;
            if (avatar) localStorage.setItem("userAvatar", avatar);
            if (nickname) localStorage.setItem("userName", nickname);
            const saved = localStorage.getItem("userInfo");
            if (saved) {
              try {
                const info = JSON.parse(saved);
                info.avatar = avatar || info.avatar;
                info.nickname = nickname || info.nickname;
                localStorage.setItem("userInfo", JSON.stringify(info));
              } catch (e) {}
            }
          }
        })
        .catch((error) => {
          this.loading = false;
          // 401 错误已经在拦截器中处理了跳转，这里只处理其他错误
          if (error.message && !error.message.includes("请登录后操作")) {
            console.error("获取用户信息失败:", error);
          }
        });
    },
    // 获取推广列表
    fetchPromotionList() {
      getPromotion({
        page: this.promotionPage,
        limit: this.promotionLimit,
      })
        .then((response) => {
          const payload = response.data || {};
          this.promotionList = payload.data || [];
          this.promotionTotal =
            Number(
              payload.total ??
                payload.total_count ??
                payload.count ??
                this.promotionList.length
            ) || 0;
        })
        .catch((error) => {
          // 401 错误已经在拦截器中处理了跳转，这里只处理其他错误
          if (error.message && !error.message.includes("请登录后操作")) {
            console.error("获取推广列表失败:", error);
          }
          this.promotionList = [];
          this.promotionTotal = 0;
        });
    },
    handlePromotionPageChange(page) {
      this.promotionPage = page;
      this.fetchPromotionList();
    },
    // 获取提现记录
    fetchWithdrawRecords() {
      getWithdrawRecords({
        page: this.withdrawPage,
        limit: this.withdrawLimit,
        status: "", // 获取所有状态的记录，可以根据需要修改
      })
        .then((response) => {
          if (response.data) {
            this.withdrawalList = response.data.list || [];
          }
        })
        .catch((error) => {
          // 401 错误已经在拦截器中处理了跳转，这里只处理其他错误
          if (error.message && !error.message.includes("请登录后操作")) {
            console.error("获取提现记录失败:", error);
          }
          this.withdrawalList = [];
        });
    },
    handleEdit() {
      this.$router.push("/profile/edit");
    },
    handleLogout() {
      this.$confirm("确定要退出登录吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          // 清除所有登录信息
          localStorage.removeItem("isLoggedIn");
          localStorage.removeItem("userName");
          localStorage.removeItem("userAvatar");
          localStorage.removeItem("userId");
          localStorage.removeItem("userInfo");
          localStorage.removeItem("token");
          this.$message.success("已退出登录");
          this.$router.push("/login");
        })
        .catch(() => {});
    },
    copyInvitationCode() {
      const inviteCode = this.userInfo.invite_code || this.invitationCode;
      if (!inviteCode) {
        this.$message.warning("暂无邀请码");
        return;
      }
      const input = document.createElement("input");
      input.value = inviteCode;
      document.body.appendChild(input);
      input.select();
      document.execCommand("copy");
      document.body.removeChild(input);
      this.$message.success("邀请码已复制到剪贴板");
    },
    handleCopyInvitationCode() {
      const inviteCode = this.userInfo.invite_code;
      if (!inviteCode) {
        this.$message.warning("暂无邀请码");
        return;
      }
      // 优先使用现代 Clipboard API
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard
          .writeText(inviteCode)
          .then(() => {
            this.$message.success("邀请码已复制到剪贴板");
          })
          .catch(() => {
            // 如果 Clipboard API 失败，回退到传统方法
            this.fallbackCopyText(inviteCode);
          });
      } else {
        // 回退到传统方法
        this.fallbackCopyText(inviteCode);
      }
    },
    fallbackCopyText(text) {
      const input = document.createElement("input");
      input.value = text;
      input.style.position = "fixed";
      input.style.opacity = "0";
      document.body.appendChild(input);
      input.select();
      try {
        document.execCommand("copy");
        this.$message.success("邀请码已复制到剪贴板");
      } catch (err) {
        this.$message.error("复制失败，请手动复制");
      }
      document.body.removeChild(input);
    },
    handleWithdraw() {
      this.withdrawAmount = "";
      this.selectedWithdrawMethod = "wechat";
      this.withdrawDialogVisible = true;
    },
    handleWithdrawConfirm() {
      // 验证提现金额
      if (!this.withdrawAmount || this.withdrawAmount === "") {
        this.$message.warning("请输入提现金额");
        return;
      }

      const amount = parseFloat(this.withdrawAmount);
      if (isNaN(amount) || amount <= 0) {
        this.$message.warning("请输入有效的提现金额");
        return;
      }

      const balance = parseFloat(this.balance) || 0;
      if (amount > balance) {
        this.$message.warning("提现金额不能超过可提现余额");
        return;
      }

      // 验证提现方式
      if (!this.selectedWithdrawMethod) {
        this.$message.warning("请选择提现方式");
        return;
      }

      // 调用提现接口
      this.withdrawLoading = true;
      applyWithdraw({
        amount: amount,
        method: this.selectedWithdrawMethod,
      })
        .then(() => {
          this.withdrawLoading = false;
          this.$message.success("提现申请提交成功");
          this.withdrawDialogVisible = false;
          this.withdrawAmount = "";
          // 刷新提现记录列表
          this.fetchWithdrawRecords();
          // 刷新用户信息（更新余额）
          this.fetchUserInfo();
        })
        .catch((error) => {
          this.withdrawLoading = false;
          this.$message.error(error.message || "提现申请失败，请稍后重试");
        });
    },
    // 点击显示银行卡号
    handleShowBankAccount() {
      if (!this.userInfo.mobile) {
        this.$message.warning("未绑定手机号，无法发送验证码");
        return;
      }

      // 发送短信验证码
      this.sendVerificationCode();
    },
    // 发送验证码
    sendVerificationCode() {
      if (this.countdown > 0) {
        return;
      }

      this.loading = true;
      sendSmsCode(this.userInfo.mobile, "default")
        .then(() => {
          this.loading = false;
          this.$message.success("验证码已发送");
          this.verifyDialogVisible = true;
          this.verifyCode = "";
          // 开始倒计时
          this.startCountdown();
        })
        .catch((error) => {
          this.loading = false;
          this.$message.error(error.message || "验证码发送失败");
        });
    },
    // 开始倒计时
    startCountdown() {
      this.countdown = 60;
      this.countdownTimer = setInterval(() => {
        this.countdown--;
        if (this.countdown <= 0) {
          clearInterval(this.countdownTimer);
          this.countdownTimer = null;
        }
      }, 1000);
    },
    // 重新发送验证码
    handleResendCode() {
      this.sendVerificationCode();
    },
    // 验证验证码
    handleVerifyCode() {
      if (!this.verifyCode || this.verifyCode.trim() === "") {
        this.$message.warning("请输入验证码");
        return;
      }

      this.verifyLoading = true;
      // 使用 checkSms 接口验证验证码
      const formData = new FormData();
      formData.append("mobile", this.userInfo.mobile);
      formData.append("event", "default");
      formData.append("captcha", this.verifyCode);

      api
        .post("/sms/check", formData)
        .then(() => {
          this.verifyLoading = false;
          this.$message.success("验证成功");
          this.showFullBankAccount = true;
          this.verifyDialogVisible = false;
          this.verifyCode = "";
          // 清除倒计时
          if (this.countdownTimer) {
            clearInterval(this.countdownTimer);
            this.countdownTimer = null;
          }
          this.countdown = 0;
        })
        .catch((error) => {
          this.verifyLoading = false;
          this.$message.error(error.message || "验证失败，请检查验证码");
        });
    },
    // 关闭验证弹窗
    handleCloseVerifyDialog() {
      this.verifyDialogVisible = false;
      this.verifyCode = "";
      // 清除倒计时
      if (this.countdownTimer) {
        clearInterval(this.countdownTimer);
        this.countdownTimer = null;
      }
      this.countdown = 0;
    },
    // 打开修改密码弹窗
    handleOpenChangePasswordDialog() {
      this.changePasswordForm = {
        oldpassword: "",
        newpassword: "",
      };
      this.changePasswordDialogVisible = true;
    },
    // 关闭修改密码弹窗
    handleCloseChangePasswordDialog() {
      this.changePasswordDialogVisible = false;
      this.changePasswordLoading = false;
      this.changePasswordForm = {
        oldpassword: "",
        newpassword: "",
      };
    },
    // 提交修改密码
    handleChangePasswordSubmit() {
      const oldpassword = this.changePasswordForm.oldpassword;
      const newpassword = this.changePasswordForm.newpassword;
      if (!oldpassword) {
        this.$message.warning("请输入旧密码");
        return;
      }
      if (!newpassword) {
        this.$message.warning("请输入新密码");
        return;
      }

      this.changePasswordLoading = true;
      changePassword({
        oldpassword,
        newpassword,
      })
        .then((response) => {
          this.$message.success(response.msg || "密码修改成功");
          this.handleCloseChangePasswordDialog();
        })
        .catch((error) => {
          this.changePasswordLoading = false;
          this.$message.error(error.message || "密码修改失败，请稍后重试");
        });
    },
    // 新建一条邮箱编辑项
    createEmailAuthItem() {
      return {
        id: null,
        email: "",
        auth_code: "",
        penName: "",
        isDefault: "0",
        weigh: 0,
      };
    },
    // 获取发件邮箱列表
    fetchSenderEmailList() {
      return getSenderEmailList()
        .then((response) => {
          const payload = response.data || {};
          const list = Array.isArray(payload.list)
            ? payload.list
            : Array.isArray(payload.data)
            ? payload.data
            : [];
          this.emailAuthList = list.map((item) => ({
            id: item.id,
            email: item.email || "",
            auth_code: item.auth_code || "",
            penName: item.pen_name || item.penName || "",
            isDefault: String(
              item.is_default === 1 || item.is_default === "1" ? 1 : 0
            ),
            weigh: item.weigh != null ? item.weigh : 0,
          }));

          if (this.emailAuthList.length === 0) {
            const first = this.createEmailAuthItem();
            first.email = "";
            first.isDefault = "";
            this.emailAuthList = [first];
          } else if (
            !this.emailAuthList.some((item) => item.isDefault === "1")
          ) {
            this.emailAuthList[0].isDefault = "1";
          }
        })
        .catch((error) => {
          this.$message.error(error.message || "获取邮箱列表失败");
          this.emailAuthList = [];
        });
    },
    // 打开授权邮箱弹窗
    handleEmailCode() {
      this.emailAuthDialogVisible = true;
      this.fetchSenderEmailList();
    },
    // 关闭授权邮箱弹窗
    closeEmailAuthDialog() {
      this.emailAuthDialogVisible = false;
      this.emailAuthList = [];
    },
    // 新增邮箱行（最多 3 条）
    addEmailAuthRow() {
      if (this.emailAuthList.length >= this.maxEmailCount) {
        this.$message.warning(`最多可设置 ${this.maxEmailCount} 个邮箱`);
        return;
      }
      const item = this.createEmailAuthItem();
      if (this.emailAuthList.length === 0) {
        item.isDefault = "1";
      }
      this.emailAuthList.push(item);
    },
    // 设置默认邮箱
    handleSetDefaultEmail(item) {
      if (!item) return;
      if (!item.id) {
        this.emailAuthList.forEach((row) => {
          row.isDefault = row === item ? "1" : "0";
        });
        return;
      }
      setDefaultSenderEmail({ id: item.id })
        .then(() => {
          this.$message.success("默认邮箱设置成功");
          this.fetchSenderEmailList();
        })
        .catch((error) => {
          this.$message.error(error.message || "设置默认邮箱失败");
        });
    },
    // 删除邮箱
    handleDeleteEmail(item, index) {
      if (!item || item.id == null) {
        this.emailAuthList.splice(index, 1);
        if (
          this.emailAuthList.length > 0 &&
          !this.emailAuthList.some((row) => row.isDefault === "1")
        ) {
          this.emailAuthList[0].isDefault = "1";
        }
        return;
      }
      deleteSenderEmail({ id: item.id })
        .then(() => {
          this.$message.success("删除成功");
          this.fetchSenderEmailList();
        })
        .catch((error) => {
          this.$message.error(error.message || "删除失败，请稍后重试");
        });
    },
    // 保存授权邮箱信息
    handleEmailAuthSave() {
      if (
        !Array.isArray(this.emailAuthList) ||
        this.emailAuthList.length === 0
      ) {
        this.$message.warning("请至少添加一个邮箱");
        return;
      }
      if (this.emailAuthList.length > this.maxEmailCount) {
        this.$message.warning(`最多可设置 ${this.maxEmailCount} 个邮箱`);
        return;
      }
      const hasDefault = this.emailAuthList.some(
        (item) => item.isDefault === "1"
      );
      if (!hasDefault) {
        this.$message.warning("请设置一个默认邮箱");
        return;
      }
      for (let i = 0; i < this.emailAuthList.length; i++) {
        const item = this.emailAuthList[i];
        if (!item.email) {
          this.$message.warning(`第 ${i + 1} 行请输入邮箱`);
          return;
        }
        if (!item.penName) {
          this.$message.warning(`第 ${i + 1} 行请输入笔名`);
          return;
        }
        if (!item.id && !item.auth_code) {
          this.$message.warning(`第 ${i + 1} 行请输入授权码`);
          return;
        }
      }

      this.emailAuthLoading = true;
      const tasks = this.emailAuthList.map((item, index) => {
        const payload = {
          email: item.email,
          auth_code: item.auth_code || "",
          pen_name: item.penName,
          is_default: item.isDefault,
          weigh:
            item.weigh != null ? item.weigh : this.emailAuthList.length - index,
        };
        return item.id
          ? editSenderEmail({
              ...payload,
              id: item.id,
            })
          : addSenderEmail(payload);
      });
      Promise.all(tasks)
        .then(() => {
          this.emailAuthLoading = false;
          this.$message.success("保存成功");
          this.closeEmailAuthDialog();
          // 刷新用户信息，获取最新状态
          this.fetchUserInfo();
        })
        .catch((error) => {
          this.emailAuthLoading = false;
          this.$message.error(error.message || "保存失败，请稍后重试");
        });
    },
    // 点击教程链接
    handleEmailAuthorizationCodeTutorial() {
      // 跳转到授权教程页面
      if (this.$router) {
        this.$router.push("/email-auth-tutorial");
      }
    },
  },
};
</script>

<style scoped lang="scss">
.profile-page {
  min-height: 100vh;
  background: linear-gradient(180deg, #fff6f8 0%, #f3f7ff 100%);
}

.profile-body {
  max-width: 1200px;
  margin: 20px auto 60px;
}

/* 用户信息区域 */
.user-info-section {
  box-shadow: 0 12px 30px rgba(31, 46, 134, 0.08);
}

.user-details {
  flex: 1;
}

.user-info-item {
  font-size: 16px;
  color: #333;

  .info-label {
    color: #666;
    margin-right: 10px;
  }
}

.email-code-btn {
  width: 120px;
  height: 34px;
  border-color: #d85a70;
  color: #d85a70;
  border-radius: 7px;
  margin-right: 10px;
}

.edit-btn {
  width: 102px;
  height: 34px;
  border-color: #d85a70;
  color: #d85a70;
  border-radius: 7px;
  margin-right: 10px;
}

.logout-btn {
  width: 102px;
  height: 34px;
  background: #d85a70;
  border-radius: 7px;
}

/* 主要内容区域 */
.main-content {
  gap: 20px;
}

.promotion-center,
.commission-section {
  box-shadow: 0 12px 30px rgba(31, 46, 134, 0.08);
  min-height: 500px;
}

/* 推广中心 */
.promotion-table-wrapper {
  border: 1px solid #ebeef5;
  border-radius: 8px;
  overflow: hidden;
}

.promotion-title {
  font-size: 16px;
  padding: 15px;
  text-align: center;
  background: #fff;
  border-bottom: 1px solid #ebeef5;
}

.promotion-table {
  margin-top: 15px;
}

/* 推广人数表格样式 - 只有外边框，没有内部网格线 */
::v-deep .promotion-list-table {
  border: none;

  .el-table__header-wrapper {
    border: none;
    background: transparent;
  }

  .el-table__body-wrapper {
    border: none;
  }

  .el-table__header {
    background: transparent;

    tr {
      background: transparent;
    }

    th {
      background: transparent !important;
      color: #212121;
      font-weight: 600;
      border: none;
      border-bottom: none;
      border-right: none;
      padding: 12px 0;

      &:last-child {
        border-right: none;
      }
    }
  }

  .el-table__body {
    tr {
      background: #fff;

      td {
        border: none;
        border-bottom: none;
        border-right: none;
        color: #000;
        padding: 12px 0;
        background: transparent;

        &:last-child {
          border-right: none;
        }
      }

      /* 单数行（奇数行）添加背景色 */
      &:nth-child(odd) {
        background: #fdf6f8;

        td {
          background: transparent;
        }
      }

      /* 偶数行保持白色 */
      &:nth-child(even) {
        background: #fff;

        td {
          background: transparent;
        }
      }

      &:last-child td {
        border-bottom: none;
      }

      &:hover {
        background: #ede7ff;

        td {
          background: transparent;
        }
      }
    }
  }

  /* 移除所有内部边框 */
  .el-table__border {
    display: none;
  }

  .el-table__border::after,
  .el-table__inner-wrapper::before {
    display: none;
  }

  /* 移除列之间的边框 */
  .el-table td,
  .el-table th {
    border-right: none !important;
  }

  .el-table th:first-child,
  .el-table td:first-child {
    border-left: none !important;
  }
}

/* 我的分佣 */
.balance-info {
  padding: 20px;
  background: #f8f9fa;
  border-radius: 12px;
}

.balance-display {
  font-size: 18px;

  .balance-icon {
    font-size: 24px;
    color: #d85a70;
    margin-right: 10px;
  }
}

/* 提现记录状态颜色 */
.withdraw-status.pending {
  color: #ffa500;
}

.withdraw-status.approved {
  color: #00cc0e;
}

.withdraw-status.rejected {
  color: #ff383c;
}

.withdraw-status.unknown {
  color: #999999;
}

.withdraw-btn {
  &:hover {
    background: #c54a60;
    border-color: #c54a60;
  }
}

.withdrawal-records {
  margin-top: 30px;
}

.withdrawal-table-wrapper {
  border: 1px solid #ebeef5;
  border-radius: 8px;
  overflow: hidden;
}

.withdrawal-title {
  font-size: 16px;
  padding: 15px;
  text-align: center;
  background: #fff;
  border-bottom: 1px solid #ebeef5;
}

/* 提现记录表格样式 - 参考推广人数表格 */
::v-deep .withdrawal-list-table {
  border: none;

  .el-table__header-wrapper {
    border: none;
    background: transparent;
  }

  .el-table__body-wrapper {
    border: none;
  }

  .el-table__header {
    background: transparent;

    tr {
      background: transparent;
    }

    th {
      background: transparent !important;
      color: #212121;
      font-weight: 600;
      border: none;
      border-bottom: none;
      border-right: none;
      padding: 12px 0;

      &:last-child {
        border-right: none;
      }
    }
  }

  .el-table__body {
    tr {
      background: #fff;

      td {
        border: none;
        border-bottom: none;
        border-right: none;
        color: #000;
        padding: 12px 0;
        background: transparent;

        &:last-child {
          border-right: none;
        }
      }

      /* 单数行（奇数行）添加背景色 */
      &:nth-child(odd) {
        background: #fdf6f8;

        td {
          background: transparent;
        }
      }

      /* 偶数行保持白色 */
      &:nth-child(even) {
        background: #fff;

        td {
          background: transparent;
        }
      }

      &:last-child td {
        border-bottom: none;
      }

      &:hover {
        background: #ede7ff;

        td {
          background: transparent;
        }
      }
    }
  }

  /* 移除所有内部边框 */
  .el-table__border {
    display: none;
  }

  .el-table__border::after,
  .el-table__inner-wrapper::before {
    display: none;
  }

  /* 移除列之间的边框 */
  .el-table td,
  .el-table th {
    border-right: none !important;
  }

  .el-table th:first-child,
  .el-table td:first-child {
    border-left: none !important;
  }
}

/* 响应式设计 */
@media (max-width: 1024px) {
  .main-content {
    flex-direction: column;
  }

  .promotion-center {
    margin-right: 0;
    margin-bottom: 20px;
  }

  .user-info-section {
    .flex {
      flex-direction: column;
      align-items: flex-start;
    }
  }
}

/* 提现方式弹窗样式 */
.withdraw-dialog ::v-deep .el-dialog {
  border-radius: 12px;
}

.withdraw-dialog ::v-deep .el-dialog__header {
  border-bottom: none;
  padding: 0;
}

.withdraw-dialog ::v-deep .el-dialog__body {
  padding: 0;
}

.withdraw-content {
  padding: 20px 0;
}

.withdraw-amount-section {
  padding-bottom: 20px;
  border-bottom: 1px solid #ebeef5;
}

.withdraw-amount-input {
  width: 100%;

  ::v-deep .el-input__inner {
    height: 50px;
    font-size: 16px;
    border-radius: 8px;
  }

  ::v-deep .el-input-group__prepend {
    background: #f5f7fa;
    border-color: #dcdfe6;
    color: #606266;
    font-weight: 500;
  }
}

.withdraw-options {
  padding: 20px 0 10px;
}

.withdraw-radio-group {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 20px;
  align-items: center;
}

.withdraw-option-item {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  cursor: pointer;
  transition: all 0.3s;

  &:hover {
    opacity: 0.8;
  }
}

.radio-icon {
  width: 20px;
  height: 20px;
  object-fit: contain;
}

.ghost {
  border: 1px solid #d85a70;

  &:hover {
    background: #fff6f8;
    border-color: #d85a70;
    color: #d85a70;
  }
}

.solid {
  &:hover {
    background: #c54a60;
    border-color: #c54a60;
  }
}

::v-deep {
  .el-dialog {
    border-radius: 12px;
  }

  .el-dialog__header {
    padding: 0;
  }
}

/* 显示银行卡按钮 */
.show-bank-btn {
  margin-left: 10px;
  padding: 0 8px;
  font-size: 12px;
  color: #d85a70;

  &:hover {
    color: #c54a60;
  }
}

/* 验证码弹窗样式 */
.verify-dialog ::v-deep .el-dialog {
  border-radius: 12px;
}

.verify-dialog ::v-deep .el-dialog__header {
  border-bottom: none;
  padding: 0;
}

.verify-dialog ::v-deep .el-dialog__body {
  padding: 20px 0;
}

.verify-content {
  padding: 20px 30px;
}

.verify-code-input {
  width: 100%;

  ::v-deep .el-input__inner {
    height: 45px;
    font-size: 16px;
    border-radius: 8px;
    padding-right: 100px;
  }

  ::v-deep .el-input__suffix {
    right: 15px;
    display: flex;
    align-items: center;
  }

  .resend-btn {
    color: #d85a70;
    font-size: 14px;
    cursor: pointer;
    user-select: none;
    white-space: nowrap;
    width: 70px;
    text-align: center;
    display: inline-block;

    &:hover:not(.disabled) {
      color: #c54a60;
    }

    &.disabled {
      color: #c0c4cc;
      cursor: not-allowed;
    }
  }
}

/* 授权邮箱弹窗样式 */
::v-deep .email-auth-dialog {
  .el-dialog {
    border-radius: 12px;
    background: #f5f7fa;
  }

  .el-dialog__header {
    padding: 0;
    border-bottom: none;
  }

  .el-dialog__body {
    padding: 0;
  }

  .el-dialog__footer {
    padding: 0 0 30px 0;
    border-top: none;
  }
}

.email-auth-title {
  font-size: 18px;
  color: #212121;
  padding: 20px 0;
  font-weight: 600;
}

.email-auth-content {
  padding: 24px 40px;
  max-height: 420px;
  overflow-y: auto;
}

.email-auth-form {
  margin-bottom: 20px;
}

.email-auth-form-row {
  flex-wrap: nowrap;
  align-items: center;
  gap: 16px;
}

.email-auth-field {
  flex: 1 1 0;
  min-width: 0;
}

.email-auth-label {
  min-width: 60px;
  font-size: 14px;
  color: #212121;
}

.email-auth-select,
.email-auth-input {
  width: 100%;

  ::v-deep .el-input__inner {
    height: 40px;
    border-radius: 6px;
    border: 1px solid #dcdfe6;
    font-size: 14px;

    &:focus {
      border-color: #d85a70;
    }

    &::placeholder {
      font-size: 14px;
      color: #212121;
    }

    &::-webkit-input-placeholder {
      font-size: 14px;
      color: #212121;
    }

    &::-moz-placeholder {
      font-size: 14px;
      color: #212121;
    }

    &:-ms-input-placeholder {
      font-size: 14px;
      color: #212121;
    }
  }
}

.email-auth-select {
  ::v-deep .el-input__inner {
    cursor: pointer;
  }
}

.email-auth-tip {
  margin-bottom: 15px;
}

.email-auth-actions {
  gap: 8px;
  min-width: 190px;
  flex: 0 0 190px;
  white-space: nowrap;
  justify-content: flex-end;
}

.email-auth-add-row {
  margin-top: 8px;
}

.email-auth-add-btn {
  border-color: #d85a70;
  color: #d85a70;
}

.email-auth-footer {
  position: static;
}

.email-auth-save-btn {
  width: 345px;
  height: 46px;
  background: #d85a70;
  border-color: #d85a70;
  color: #fff;
  border-radius: 57px;
  font-size: 16px;
  font-weight: 500;

  &:hover {
    background: #c54a60;
    border-color: #c54a60;
  }

  &:active {
    background: #b83a50;
    border-color: #b83a50;
  }
}

::v-deep {
  .email-auth-dialog .el-dialog {
    border-radius: 12px;
  }
}
</style>
